export { icons, type IconStyle, type IconName } from "./icons";
export interface SVG {
  attrs: Record<string, string>;
  width?: string;
  height?: string;
  readonly html: string;
  readonly symbol: string;
  setAttrs(attributes: Record<string, string | null | undefined>): this;
  getAttrs(): string;
  innerHTML: string;
}

export function str2svg(content: string){
  const convert = /<svg(?:\s(.*?))?>(.*?)<\/svg>/mis;
  const convertAttrs = /[a-z][a-z-\:]+(?:=(?:'[^']+'|"[^"]+"))?/gi;
  const [data, attr, innerHTML] = convert.exec(content) ?? ["", "", ""];
  const svg:SVG = {
    attrs: {},

    get html():string {
      /*
      var attrs = this.attrs;
      if(Object.hasOwn(attrs, "width"))
        delete attrs.width;
      if(Object.hasOwn(attrs, "height"))
        delete attrs.height;
      */
      this.setAttrs({
        width: this.width,
        height: this.height
      })
      return `<svg ${this.getAttrs()}>${this.innerHTML}</svg>`;
    },
    get symbol():string {
      return `<symbol ${this.getAttrs()}>${this.innerHTML}</symbol>`;
    },
    // attrs: [...attr.matchAll(convertAttrs)].map(m => m[0]),//convertAttrs.exec(attr),
    setAttrs(attributes: Record<string, string|null>) {
      this.attrs = Object.assign(this.attrs, attributes);
      return this;
    },
    getAttrs() {
      return Object.entries(this.attrs).map(a => a[0] + (a[1] ? `="${a[1]}"` : "")).join(' ');
    },
    innerHTML: innerHTML,
  };
  [...attr.matchAll(convertAttrs)].forEach(m => {
    let r = /([a-z][a-z-\:]+)(?:=('[^']+'|"[^"]+"|\w+))?/im.exec(m[0]);
    if(r)
      svg.setAttrs({[r[1]]: r[2].replace(/^["']+|["']+$/gm,'')})
  });
  if(/viewbox=(?:['"]\d+\s\d+\s\d+\s\d+['"])/i.test(attr) && !/width=(?:'\d+'|"\d+")/i.test(attr) && !/height=(?:'\d+'|"\d+")/i.test(attr)) {
    let viewbox = /viewbox=(?:['"](\d+)\s(\d+)\s(\d+)\s(\d+)['"])/i.exec(attr);
    if(viewbox) {
      let w = parseInt(viewbox[3]) - parseInt(viewbox[1]),
        h = parseInt(viewbox[4]) - parseInt(viewbox[2]);
      // svg.setAttrs({"width": w.toString(), "height": h.toString()});
      svg.width = w.toString();
      svg.height = h.toString();
      // svg.attrs();
      // svg.data = `<svg ${svg.attrs.join(' ')}>${svg.innerHTML}</svg>`;
    }
  }
  return svg;
}